import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // 👇 直接禁用滚动重置
    // 如果以后想调试，可以打开日志看看
    // console.debug("[ScrollToTop] ignore on route:", pathname);
  }, [pathname]);
  return null;
}
